import React from "react";
import PreHeader from "./PreHeader";

interface HeaderProps {
  pathname?: string;
}

export default function Header({ pathname = "/" }: HeaderProps) {
  const [openMenu, setOpenMenu] = React.useState<string | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const closeTimerRef = React.useRef<NodeJS.Timeout | null>(null);

  const isActive = (path: string) => {
    const currentPath = pathname.toLowerCase();
    return currentPath === path || currentPath.startsWith(path + "/");
  };

  const navigate = (event: React.MouseEvent, href: string) => {
    event.preventDefault();
    window.history.pushState({}, "", href);
    window.dispatchEvent(new PopStateEvent("popstate"));
    setOpenMenu(null);
    setMobileMenuOpen(false);
  };

  const handleMenuItemHover = (name: string) => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    setOpenMenu(name);
  };

  const handleMenuItemLeave = () => {
    closeTimerRef.current = setTimeout(() => {
      setOpenMenu(null);
    }, 150);
  };

  const getDaysUntilDuoDay = () => {
  // The DuoDay date below must be updated manually
  const targetDate = new Date("2027-05-26");
  const today = new Date();

  const diffInMs = targetDate.getTime() - today.getTime();

  // Divide milliseconds by 1000 * 60 * 60 * 24 to return days
  return Math.max(
    0,
    Math.ceil(diffInMs / (1000 * 60 * 60 * 24))
  );
};

const daysLeft = getDaysUntilDuoDay();

  return (
    <>
      <PreHeader />

        <div className="duoday-countdown">
          <span className="duoday-countdown__number">
          {daysLeft}
          </span>
          <span className="duoday-countdown__label">
            Tage bis zum nächsten DUOday
          </span>
        </div>

      <header className="app-header">
        <div className="header-inner">
          <div className="brand">
            <a
              href="/"
              onClick={(event) => navigate(event, "/")}
              title="Startseite"
            >
              <img
                src="/DuoDay.png"
                alt="Duoday Logo"
                className="brand__logo"
                height="48"
                loading="eager"
                decoding="async"
              />
            </a>
          </div>

          <button
            className="nav__toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menü"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav
            className={`nav${mobileMenuOpen ? " mobile-open" : ""}`}
            aria-label="Hauptnavigation"
          > 
            <div className="nav__item">
              <button
                className={`nav__button${isActive("/") ? " nav__button--active" : ""}`}
                type="button"
                onClick={(event) => navigate(event, "/")}
                title="Aktuelles"
              >
                Aktuelles
              </button>
            </div>

            <div className="nav__item">
              <button
                className={`nav__button${isActive("/presse") ? " nav__button--active" : ""}`}
                type="button"
                onClick={(event) => navigate(event, "/presse")}
                title="Presse"
              >
                Presse
              </button>
            </div>

            <div
              className={`nav__item${openMenu === "workgroup" ? " open" : ""}`}
              onMouseEnter={() => handleMenuItemHover("workgroup")}
              onMouseLeave={handleMenuItemLeave}
            >
              <button
                className={`nav__button${isActive("/workgroup") ? " nav__button--active" : ""}`}
                type="button"
                onClick={(event) => navigate(event, "/arbeitsgruppe")}
                title="Arbeitsgruppe"
              >
                Arbeitsgruppe
              </button>
            </div>

            <div
              className={`nav__item${openMenu === "organizers" ? " open" : ""}`}
              onMouseEnter={() => handleMenuItemHover("organizers")}
              onMouseLeave={handleMenuItemLeave}
            >
              <button
                className={`nav__button${isActive("/organizers") ? " nav__button--active" : ""}`}
                type="button"
                onClick={(event) => navigate(event, "/mitorganisatoren")}
                title="Mitorganisatoren"
              >
                Mitorganisatoren
              </button>
            </div>

            <div
              className={`nav__item${openMenu === "archive" ? " open" : ""}`}
              onMouseEnter={() => handleMenuItemHover("archive")}
              onMouseLeave={handleMenuItemLeave}
            >
              <button
                className={`nav__button${isActive("/archive") ? " nav__button--active" : ""}`}
                type="button"
                onClick={(event) => navigate(event, "/archiv")}
                title="Archiv"
              >
                Archiv
              </button>
            </div>
          </nav>

          <a
            href="https://forms.office.com/Pages/ResponsePage.aspx?id=JCvNjHArGkCpM79AEACeXqmUCRjg9xtKpiw4tCfnLEJURTFaMDBXMVQxTzlEWldIWUFRMU9KWDVIRi4u"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--secondary"
          >
            Als Unternehmen anmelden
          </a>
        </div>
      </header>
    </>
  );
}
